import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Form, Formik } from 'formik'
import centrosCustoStore from 'src/modules/centros-custo/store'
import { StatusCentroCusto } from 'src/modules/centros-custo/types'
import SelectInput from '../../components/Formik/Forms/SelectInput'
import { alterarStatus } from '../../modules/centros-custo/hooks/centroCustoRepository'
import snackbarStore from '../../stores/snackbar'

interface CentrosCustoProps {
  open: boolean
  handleClose: () => void
  primaryAction?: () => void
  status: any
  optionsStatus: string[]
  id: string
}

function CentrosCustoDialog({
  open,
  handleClose,
  primaryAction,
  status,
  optionsStatus,
  id
}: CentrosCustoProps) {
  const handlePrimaryAction = () => {
    handleClose()
    primaryAction && primaryAction()
  }

  const initialValues: {
    status: StatusCentroCusto
    newStatus: any
  } = {
    status: status,
    newStatus: ''
  }

  function getOptions(optionsStatus: string[]) {
    const options = optionsStatus.map((value: string) => {
      return { label: value, value }
    })
    return options
  }

  const handleSubmit = async (data: {
    status: StatusCentroCusto
    newStatus: any
  }) => {
    const res = await alterarStatus(id, data.newStatus)
    if (res.ok) {
      centrosCustoStore.centrosCusto.populate()
      snackbarStore.setMessage('Status alterado com sucesso!')
    } else {
      snackbarStore.setMessage(
        res.data?.message ?? 'Error ao alterar status do Centro de custo'
      )
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="alert-dialog-title">
        Editar Status do Centro de Custo
      </DialogTitle>
      <DialogContent>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            values
          }) => (
            <Form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <SelectInput
                    name="newStatus"
                    label="Selecionar Status"
                    options={getOptions(optionsStatus)}
                  />
                </Grid>

                <Grid container justifyContent="flex-end">
                  <DialogActions>
                    <Button onClick={handleClose} color="default" autoFocus>
                      Voltar
                    </Button>
                    <Button
                      onClick={handlePrimaryAction}
                      disabled={!!!values.newStatus || isSubmitting}
                      color="primary"
                      type="submit"
                      autoFocus
                    >
                      Confirmar
                    </Button>
                  </DialogActions>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

export default CentrosCustoDialog
